module.exports = __webpack_public_path__ + "img/pres_3.3290ed73.jpg";